<template>
  <Transition
    enter-active-class="duration-500 ease-out delay-50 transform-gpu"
    enter-from-class=" transform  opacity-0"
    enter-to-class=" opacity-100"
    leave-active-class="duration-200 ease-in delay-50 transform-gpu"
    leave-from-class=" opacity-100"
    leave-to-class="transform   opacity-0 "
    mode="in-out"
    :show="loading"
  >
    <div
      v-if="loading"
      class="fixed inset-0 flex justify-center items-center z-[9999]"
      :class="hideTransparent ? 'bg-white' : 'bg-primary/30'"
    >
      <div
        class="flex items-center gap-4"
        :class="hideTransparent ? 'text-primary' : 'text-white'"
        role="status"
      >
        <svg
          class="animate-spin -ml-1 h-7 w-7"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span class="text-2xl font-medium">{{ $t('Loading') }}...</span>
      </div>
    </div>
  </Transition>
</template>

<script setup>
  defineProps({
    loading: Boolean,
    hideTransparent: Boolean,
  });
</script>
